import { render } from "./ScummInterface.vue?vue&type=template&id=b8317e94&bindings={\"gameStatus\":\"props\",\"currentVerb\":\"props\",\"items\":\"props\",\"subject\":\"props\",\"object\":\"props\",\"thingHoveredOn\":\"props\",\"needObject\":\"props\",\"lastCommand\":\"props\",\"conversation\":\"props\",\"recommendedVerb\":\"props\"}"
import script from "./ScummInterface.vue?vue&type=script&lang=js"
export * from "./ScummInterface.vue?vue&type=script&lang=js"

import "./ScummInterface.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script